import { User as UserResponse } from '@/DTOS/User/Response/User';
import { UserPermission } from '@/DTOS/User/Response/UserPermission';
import { EditOutlined, FileWordOutlined } from '@ant-design/icons';
import { Button, Tag, Tooltip } from 'antd';
import moment from 'moment';

export const UserColumn: any = (
  handleEdit: (record: UserResponse) => void,
  handleDocs: (record: UserResponse) => void,
) => [
  {
    title: 'User Id',
    dataIndex: 'id',
    key: 'id',
    hidden: true,
  },
  {
    title: 'Nume',
    dataIndex: ['name'],
    key: 'name',
    width: 150,
    render: (text: string) => (
      <Tooltip title={text}>
        <div className='ellipsis-cell'>{text}</div>
      </Tooltip>
    ),
  },
  {
    title: 'Email',
    dataIndex: ['email'],
    key: 'email',
    width: 150,
    render: (text: string) => (
      <Tooltip title={text}>
        <div className='ellipsis-cell'>{text}</div>
      </Tooltip>
    ),
  },

  // {
  //   title: 'Telefon',
  //   dataIndex: ['userPersonalData', 'phone'],
  //   key: 'userPersonalDataPhone',
  //   width: 150,
  // },
  // {
  //   title: 'Telefon Personal',
  //   dataIndex: ['userPersonalData', 'phonePersonal'],
  //   key: 'userPersonalDataPhonePersonal',
  //   width: 170,
  // },
  // {
  //   title: 'Cnp',
  //   dataIndex: ['userPersonalData', 'cnp'],
  //   key: 'userPersonalDataCnp',
  //   width: 150,
  //   render: (text: string) => (
  //     <Tooltip title={text}>
  //       <div className='ellipsis-cell'>{text}</div>
  //     </Tooltip>
  //   ),
  // },
  {
    title: 'Permisiuni',
    dataIndex: 'userPermission',
    key: 'rols',
    width: 300,
    render: (userPermission?: UserPermission) => (
      <>
        {userPermission?.rols?.map((rol: string, index: number) => (
          <Tag color={'blue'} key={index}>
            {rol}
          </Tag>
        ))}
      </>
    ),
  },
  {
    title: 'Utilizator',
    dataIndex: 'name',
    key: 'name',
    hidden: true,
  },
  {
    title: 'Configuratie',
    dataIndex: 'userPermission',
    key: 'configuration',
    width: 150,
    render: (userPermission?: UserPermission) => (
      <div className='configuration'>
        {userPermission?.configuration ? (
          <Tag color={'blue'}>{userPermission.configuration}</Tag>
        ) : (
          <Tag color={'blue'}>-</Tag>
        )}
      </div>
    ),
    hidden: true,
  },
  // {
  //   title: 'Seria',
  //   dataIndex: ['userPersonalData', 'series'],
  //   key: 'userPersonalDataSeries',
  //   width: 150,
  // },
  // {
  //   title: 'Nr. Seria',
  //   dataIndex: ['userPersonalData', 'seriesNo'],
  //   key: 'userPersonalDataSeriesNo',
  //   width: 150,
  //   render: (text: string) => (
  //     <Tooltip title={text}>
  //       <div className='ellipsis-cell'>{text}</div>
  //     </Tooltip>
  //   ),
  // },
  // {
  //   title: 'SPCLEP',
  //   dataIndex: ['userPersonalData', 'spclep'],
  //   key: 'userPersonalDataSpclep',
  //   width: 150,
  //   render: (text: string) => (
  //     <Tooltip title={text}>
  //       <div className='ellipsis-cell'>{text}</div>
  //     </Tooltip>
  //   ),
  // },
  // {
  //   title: 'Data Nasterii',
  //   dataIndex: ['userPersonalData', 'dateOfBirth'],
  //   key: 'userPersonalDataDateOfBirth',
  //   width: 150,
  //   render: (text: string) => (
  //     <Tooltip title={text}>
  //       <Tag color={'blue'}>{!!text ? moment(text).format('DD-MM-YYYY') : '-'}</Tag>
  //     </Tooltip>
  //   ),
  // },
  // {
  //   title: 'Adresa',
  //   dataIndex: ['userPersonalData', 'address'],
  //   key: 'userPersonalDataAddress',
  //   width: 150,
  //   render: (text: string) => (
  //     <Tooltip title={text}>
  //       <div className='ellipsis-cell'>{text}</div>
  //     </Tooltip>
  //   ),
  // },
  // {
  //   title: 'Judet',
  //   dataIndex: ['userPersonalData', 'county'],
  //   key: 'userPersonalDataCounty',
  //   width: 150,
  // },
  {
    title: 'Creat La',
    dataIndex: 'createDate',
    key: 'createDate',
    width: 170,
    render: (createdAt?: string) => {
      return (
        <Tooltip title={createdAt ? moment(createdAt).format('DD-MM-YYYY') : '-'}>
          <div className='ellipsis-cell'>{createdAt ? moment(createdAt).format('DD-MM-YYYY') : '-'}</div>
        </Tooltip>
      );
    },
  },
  {
    title: 'Status',
    dataIndex: 'isActive',
    key: 'isActive',
    width: 150,
    render: (isActive: boolean) => (isActive ? 'Activ' : 'Inactiv'),
  },
  {
    title: 'Actiune',
    key: 'actions',
    render: (record: UserResponse) => (
      <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <Tooltip title='Modifica'>
          <Button className='circle-menu-item' icon={<EditOutlined />} onClick={() => handleEdit(record)} />
        </Tooltip>
        <Tooltip title='Descarca Fisier'>
          <Button className='circle-menu-item' icon={<FileWordOutlined />} onClick={() => handleDocs(record)} />
        </Tooltip>
      </div>
    ),
    width: 150,
    fixed: 'right', // This ensures the column is always visible on the right side
  },
];
